"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDaytripClientFromHeader = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function getDaytripClientFromHeader(clientTypeHeader, clientPlatformHeader) {
    // X-Daytrip-Client-Platform: platform
    const hasNoClientTypeHeader = !clientTypeHeader || Array.isArray(clientTypeHeader);
    const hasNoClientPlatformHeader = !clientPlatformHeader || Array.isArray(clientPlatformHeader);
    if (hasNoClientTypeHeader) {
        return { name: legacy_enums_1.ClientType.Unknown };
    }
    // X-Daytrip-Client: (client) (version)-(revision)
    const [name, versionWithRevision] = clientTypeHeader.split(" ");
    const [version, revision] = versionWithRevision?.split("-") ?? [];
    if (hasNoClientPlatformHeader) {
        return {
            name,
            version,
            revision,
        };
    }
    const platform = clientPlatformHeader;
    return {
        name,
        version,
        revision,
        platform,
    };
}
exports.getDaytripClientFromHeader = getDaytripClientFromHeader;
//# sourceMappingURL=getDaytripClientFromHeader.js.map